var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"title":_vm.value ? _vm.enabledTitle : _vm.disabledTitle}},[_vm._v(" "+_vm._s(_vm.value ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }